import { useEffect, useState } from "react";
import { t as translate, getLanguage, setLanguage, subscribe, tLang, tMulti, tTag} from "./local";

export function useTranslation() {
  const [lang, setLang] = useState(getLanguage());
  useEffect(() => {
    const unsubscribe = subscribe(setLang);
    return unsubscribe;
  }, []);

  return {
    t: translate,
    language: lang,
    setLanguage,
    getLanguage,
    tLang,
    tMulti,
    tTag
  };
}